import photos from "./dataset/photos.json";

export default photos;